<template>
  <about></about>
</template>
<script>
import about from '@aboutPC/about.vue';

export default {
  name: "about-pc",
  components: {
    about
  }
}
</script>
<style lang="scss" scoped>

</style>